const API_URL = '    https://vmi1977988.contaboserver.net';
// const API_URL = '    https://vmi1977988.contaboserver.net'; // Décommentez pour le développement local

export default API_URL;
